/* G4 (5 Oct 2026): back-in-stock alert on the PDP (snippets/ma-notify.liquid). Shown only while the chosen variant is sold out.
   Submits the Shopify customer form in place (tags newsletter, back-in-stock, bis-<handle>); the Brevo relay mirrors it. No dependencies. */
(function () {
  var box = document.querySelector('[data-mx-notify]'); if (!box || box.__mx) return; box.__mx = 1;
  var label = document.querySelector('[data-mx-add-label]'); if (!label) return;
  var root = label.closest('.mx-pdp') || document;
  var form = box.querySelector('form'), msg = box.querySelector('[data-mx-notify-m]'), head = box.querySelector('[data-mx-notify-t]');
  var tags = box.querySelector('[data-mx-notify-tags]'), base = tags ? tags.value : '';
  var vars = []; try { vars = JSON.parse(root.querySelector('[data-mx-variants]').textContent); } catch (e) {}
  function chosen() {
    var idIn = root.querySelector('form input[name="id"]'); if (!idIn) return null;
    return vars.find(function (v) { return String(v.id) === String(idIn.value); }) || null;
  }
  function sync() {
    var out = /sold out/i.test(label.textContent || '');
    if (out && !box.classList.contains('is-done')) {
      var v = chosen(), w = v && v.o ? v.o.filter(function (x) { return x && x !== 'Default Title'; }).join(' / ') : '';
      head.textContent = w ? 'Email me when ' + w + ' is available.' : 'Email me when it\'s available.';
      if (tags) tags.value = base + (v ? ', bis-v' + v.id : '');
      box.hidden = false;
    } else if (!out) { box.hidden = true; }
  }
  new MutationObserver(sync).observe(label, { childList: true, characterData: true, subtree: true });
  root.addEventListener('change', function () { setTimeout(sync, 0); });
  sync();
  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    var b = form.querySelector('button[type="submit"]'); b.disabled = true; msg.textContent = '';
    try {
      var res = await fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html' } });
      if (/challenge/.test(res.url)) { form.submit(); return; }
      if (!res.ok) throw new Error('post');
      box.classList.add('is-done'); msg.textContent = 'Thank you. We will email you when it is available.';
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'back_in_stock_signup', item: base }); } catch (er) {}
    } catch (er) { b.disabled = false; msg.textContent = 'Could not save that. Please try again.'; }
  });
})();
